import { createListSelector } from 'redux/utils'

export const selectShortFavouriteData = createListSelector('ShortFavourite')
